<template>
    <page :busy="busy" :tabs="tabs" class="work-orders-info" :compact-mobile-view="true">
        <b-container fluid class="my-3" :style="{ height: '225px' }">
            <template v-if="selectedTab === 'Problem'">
                <work-orders-problem :actionType="actionType" :canEdit="canEdit" @busy="onBusy"></work-orders-problem>
            </template>
            <template v-else-if="selectedTab === 'Materials and Expenses'">
                <work-orders-material-expenses
                    :actionType="actionType"
                    :canEdit="canEdit"
                ></work-orders-material-expenses>
            </template>
            <template v-else-if="selectedTab === 'Internal Notes'">
                <validation-observer v-slot="{ meta }" :initial-valies="workOrderToSave.internalNotes">
                    {{ setInvalid(!meta.valid) }}
                    <validation-provider rules="noScript" name="internalNotes" v-slot="{ errors, handleChange }">
                        <form-textarea
                            trim
                            no-resize
                            class="mb-2"
                            rows="10"
                            id="work-orders-info-notes"
                            v-model="workOrderToSave.internalNotes"
                            :disabled="!canEdit"
                            :error="errors[0]"
                            @input="handleChange"
                        ></form-textarea>
                    </validation-provider>
                </validation-observer>
            </template>
        </b-container>
    </page>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import FormTextarea from '../../../generic/form-textarea/form-textarea.vue';
    import Modal from '../../../generic/modal/modal.vue';
    import ResponsiveButton from '../../../generic/responsive-button/responsive-button.vue';
    import API from '../../../../api';
    import Page from '../../../generic/page/page.vue';
    import WorkOrdersProblem from './work-orders-problem.vue';
    import WorkOrdersMaterialExpenses from './work-orders-material-expenses.vue';
    import { WorkOrderActionType } from '../../../../constants';

    export default {
        name: 'WorkOrdersInfo',
        components: {
            Page,
            Modal,
            FormTextarea,
            ResponsiveButton,
            WorkOrdersProblem,
            WorkOrdersMaterialExpenses,
        },
        props: {
            actionType: {
                type: String,
                default: WorkOrderActionType.Create,
            },
            canEdit: {
                type: Boolean,
                default: true,
            },
        },
        inject: ['setGlobalInvalid'],
        data() {
            return {
                selectedTab: 'Problem',
                invalid: false,
                busy: false,
                tabs: [
                    {
                        title: `Problem`,
                        active: true,
                        callback: (tabTitle) => this.tabClick(tabTitle),
                    },
                    {
                        title: `Materials and Expenses`,
                        active: false,
                        callback: (tabTitle) => this.tabClick(tabTitle),
                    },
                    {
                        title: `Internal Notes`,
                        active: false,
                        callback: (tabTitle) => this.tabClick(tabTitle),
                    },
                ],
            };
        },
        computed: {
            ...mapGetters('workOrders', ['workOrderToSave']),
        },
        methods: {
            ...mapActions('workOrders', ['updateWorkOrderToSave']),
            setInvalid(isInvalid) {
                this.invalid = isInvalid;
                this.setGlobalInvalid(isInvalid);
            },
            tabClick(selectedTabTitle) {
                this.selectedTab = selectedTabTitle;
                this.tabs.forEach((tab) => {
                    tab.active = tab.title === selectedTabTitle;
                });
            },
            onBusy(busy) {
                this.$emit('busy', busy);
            },
        },
        watch: {
            'workOrderToSave.internalNotes': function (internalNotes) {
                this.updateWorkOrderToSave({ internalNotes });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .work-orders-info {
        width: 100%;
    }
</style>
